import { render, staticRenderFns } from "./VDevice.vue?vue&type=template&id=f3f68f56"
import script from "./VDevice.vue?vue&type=script&lang=js"
export * from "./VDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports